<template>
  <div class="material-menu" @scroll="scrollEvent" ref="materialMenu">
    <div class="material-menu-top">
      <MenuHeader title="素材" />
      <TagMenu
        :tagList="tagList"
        :handleTagClick="handleTagClick"
        :currentOp="currentOp"
        v-show="!showingMenuType || revealMask"
      />
      <div class="material-back" v-show="showingMenuType && !revealMask">
        <a-button @click="back" type="link" class="material-back__btn">
          <span class="anticon">
            <span class="el-icon-back material-back__icon" />
          </span>
          返回
        </a-button>
      </div>
      <a-input-group class="filter-box" v-if="showingMaterials || presetType">
        <FilterBox
          v-if="showingMaterials"
          :panelList="panelList"
          @confirm="handleOptionConfirm"
          class="ant-input-group-addon"
        >
          <template
            v-if="currentOp === 'mine' && !currentLiFisherSite"
            #panel1="{ item }"
          >
            <a-empty
              v-if="!materialTags.length"
              :style="{
                margin: '16px auto'
              }"
              :image="defaultImage"
              description="暂无标签数据"
            />
            <template v-else>
              <a-radio-group
                v-decorator="[item.prop, { initialValue: item.initial || '' }]"
                :disabled="item.disabled"
              >
                <a-radio
                  v-for="radioItem in item.list"
                  :value="radioItem.value"
                  :disabled="radioItem.disabled"
                  :key="radioItem.value"
                >
                  {{ radioItem.name }}
                </a-radio>
              </a-radio-group>
              <a-button
                type="link"
                block
                :disabled="materialTagTotal <= materialTagPage * 20"
                @click="loadNextMaterialTags"
              >
                加载更多
              </a-button>
            </template>
          </template>
        </FilterBox>
        <a-input-search
          :placeholder="
            currentOp === 'mine' ? '输入文件名或标签查询' : '请输入搜索关键字'
          "
          @search="onSearch"
          class="material-menu-input"
          :disabled="searchDisabled"
          allow-clear
        />
      </a-input-group>
      <template v-if="!isFisher">
        <div
          v-show="
            currentOp === 'mine' && !currentLiFisherSite && !myMateriaChecked
          "
          class="upload-box"
        >
          <a-button
            class="upload-type"
            type="primary"
            @click="toggleUploadDialog(true)"
          >
            本地上传
          </a-button>
          <a-popover
            :visible="codeBoxShow"
            placement="right"
            trigger="click"
            @visibleChange="toggleCodeBoxDialog"
          >
            <div
              slot="content"
              class="code-box"
            >
              <div
                id="qrcode"
                ref="qrcode"
                class="qrcode"
              />
              <div
                v-if="qrcodeOverdue"
                class="qrcode-overdue"
              >
                二维码已过期，请<span @click="repaintQrcode">重新生成</span>
              </div>
            </div>
            <a-button class="upload-type" type="primary"> 手机上传 </a-button>
          </a-popover>
        </div>
      </template>
      <template v-if="isFisher">
        <div
          v-show="
            currentOp === 'mine' && currentLiFisherSite && !myMateriaChecked
          "
          class="upload-box"
        >
          <uploadButton
          @upload="onUpload"></uploadButton>
        </div>
      </template>
      <div
        class="check-operation"
        v-show="myMateriaChecked && currentOp === 'mine'"
      >
        <a-button
          type="primary"
          :disabled="!!currentLiFisherSite"
          @click="handleAddTags"
        >
          <a-icon theme="filled" type="tags" />
          标签
        </a-button>
        <a-button
          type="danger"
          :disabled="!!currentLiFisherSite"
          @click="delCheckList"
        >
          <a-icon theme="filled" type="delete" />
          删除
        </a-button>
        <a-button @click="cancelCheck">取消</a-button>
      </div>
      <a-radio-group
        button-style="solid"
        v-model="publicType"
        v-if="showingMenuType === 'materials'"
        class="header-radio-group"
      >
        <a-radio-button value="hot">热门素材</a-radio-button>
        <a-radio-button value="common">常用素材</a-radio-button>
      </a-radio-group>
      <a-radio-group
        button-style="solid"
        v-model="backgroundType"
        v-if="presetType === 'background'"
        class="header-radio-group"
      >
        <a-radio-button value="8">图片背景</a-radio-button>
        <a-radio-button value="9">视频背景</a-radio-button>
      </a-radio-group>
      <a-radio-group
        button-style="solid"
        v-model="iconType"
        v-if="presetType === 'icons'"
        class="header-radio-group"
      >
        <a-radio-button value="Outline">
          {{ themeNames.Outline }}
        </a-radio-button>
        <a-radio-button value="Fill">
          {{ themeNames.Fill }}
        </a-radio-button>
        <a-radio-button value="TwoTone">
          {{ themeNames.TwoTone }}
        </a-radio-button>
      </a-radio-group>
      <material-category
        v-show="catShow"
        :list="presetsCats"
        @itemClick="toggleCats($event.id)"
        :selected="catsActive"
        :height.sync="catsHeight"
        :collapsed.sync="categoryCollapsed"
      />
    </div>
    <div class="empty" :style="{ height: catSpacerHeight + 'px' }"></div>
    <MaterialStyleList
      ref="MaterialStyleList"
      :dataList="materialList"
      :loadingStatus="loadingStatus"
      :is-collect="false"
      :fn="addMaterialItem"
      :replace="replaceMaterialItem"
      :handleStampUrl="handleStampUrl"
      :editStatus="editStatus"
      v-if="showingMaterials"
      :mine="currentOp === 'mine'"
      :liFisherActive="!!currentLiFisherSite"
      @top="handleTop"
      @delete="handleDelete"
      @update="fetchMaterialList"
      @tagupdate="reloadMaterialTags"
    >
      <template v-if="!isFisher">
      <template v-if="liFisherSites.length && currentOp === 'mine'">
        <div
          v-if="currentLiFisherSite"
          @click="exitLiFisherSite"
          class="folder folder--back"
        >
          <span class="folder__text">返回</span>
        </div>
        <div v-else @click="enterLiFisherSite" class="folder folder--lifisher">
          <span class="folder__text">小渔夫素材</span>
        </div>
      </template>
      </template>
    </MaterialStyleList>
    <icon-list
      v-else-if="presetType === 'icons'"
      :keyword="material"
      :theme="iconType"
    />
    <template v-else-if="presetType">
      <a-spin
        :spinning="loadingStatus === 'loading'"
        class="video-template-list"
      >
        <!-- 消除loading的背景色 -->
        <span v-if="loadingStatus === 'loading'"></span>
        <a-empty
          v-if="!presets.length && loadingStatus !== 'loading'"
          :style="{
            margin: '32px 30px 0 0',
            flexGrow: 1,
            opacity: loadingStatus === 'loading' ? 0 : 1,
            transition: '.3s'
          }"
          :image="defaultImage"
        />
        <template v-if="presetType === '1'">
          <div
            v-for="item in presets"
            :key="item.id"
            class="video-template-item"
            @click="onClickItem('1', item)"
          >
            <img
              v-if="item.attribute_name == '标准'"
              title="标准"
              class="meal-icon"
              src="/preview/icon/user_meal1.png"
              alt="标准"
            />
            <img
              v-else-if="item.attribute_name == '专业'"
              class="meal-icon"
              title="专业"
              src="/preview/icon/user_meal2.png"
              alt="专业"
            />
            <img
              v-else-if="item.attribute_name == '旗舰'"
              class="meal-icon"
              title="旗舰"
              src="/preview/icon/user_meal3.png"
              alt="旗舰"
            />
            <img
              v-if="item.thumbnail"
              :src="item.thumbnail + '?x-oss-process=image/resize,w_216'"
              alt="Preset Preview"
              class="video-clip-custom-img"
            />
            <div v-else class="video-clip-custom-img" />
            <div :title="item.name" class="video-clip-custom-title">
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-else-if="presetType === '2'">
          <div
            v-for="item in presets"
            :key="item.id"
            class="sticker-item"
            @click="onClickItem('2', item)"
          >
            <span
              @click.stop="starClick(item)"
              class="tem_used_icon"
              :class="{ block: item.is_collect }"
              :title="item.is_collect ? '取消收藏' : '收藏'"
              :style="{
                'background-image': item.is_collect
                  ? 'url(/preview/icon/icon_collected.png)'
                  : 'url(/preview/icon/icon_collect.png)'
              }"
            ></span>
            <img
              v-if="item.attribute_name == '标准'"
              title="标准"
              class="meal-icon"
              src="/preview/icon/user_meal1.png"
              alt="标准"
            />
            <img
              v-else-if="item.attribute_name == '专业'"
              class="meal-icon"
              title="专业"
              src="/preview/icon/user_meal2.png"
              alt="专业"
            />
            <img
              v-else-if="item.attribute_name == '旗舰'"
              class="meal-icon"
              title="旗舰"
              src="/preview/icon/user_meal3.png"
              alt="旗舰"
            />
            <div class="sticker-item__content" :style="stickerStyle(item)" />
          </div>
        </template>
        <template v-if="presetType === 'background'">
          <div
            v-for="item in presets"
            :key="item.id"
            class="video-template-item"
          >
            <img
              v-if="item.attribute_name == '标准'"
              title="标准"
              class="meal-icon"
              src="/preview/icon/user_meal1.png"
              alt="标准"
            />
            <img
              v-else-if="item.attribute_name == '专业'"
              class="meal-icon"
              title="专业"
              src="/preview/icon/user_meal2.png"
              alt="专业"
            />
            <img
              v-else-if="item.attribute_name == '旗舰'"
              class="meal-icon"
              title="旗舰"
              src="/preview/icon/user_meal3.png"
              alt="旗舰"
            />
            <div class="background-previewer" v-if="item.thumbnail">
              <img
                :src="backgroundThumbnail(item.thumbnail)"
                alt="Preset Preview"
                class="video-clip-custom-img"
                @click="addBackground(item)"
              />
              <a-button
                class="background-previewer__btn"
                :icon="backgroundType === '9' ? 'caret-right' : 'zoom-in'"
                type="link"
                @click="previewBackground(item)"
              />
            </div>
            <div
              v-else
              class="video-clip-custom-img"
              @click="addBackground(item)"
            />
            <div
              :title="item.name"
              class="video-clip-custom-title"
              @click="addBackground(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template v-else-if="lottieType">
          <lottie-preview
            v-for="item in presets"
            :item="item"
            :key="item.id"
            :class="lottieType === 2 ? 'effect-sticker-item' : 'sticker-item'"
            :url="item.url"
            :lottieId="item.id"
            :attributeName="item.attribute_name"
            @click.native="onClickItem('lottie', item, lottieType)"
          />
        </template>
      </a-spin>
    </template>

    <div v-else>
      <!-- <a-button
        v-for="type in presetTypes"
        :key="type.value"
        @click="handlePresetType(type)"
        class="preset-type-item"
        :icon="type.icon"
      >
        <a-icon
          v-if="type.customIcon"
          :component="icons[type.customIcon]"
          class="preset-type-item__icon"
        />
        {{ type.name }}
      </a-button> -->
      <MaterialLibraryList
        @clickPresetType="handlePresetType"
        @handleItem="handleOnClickItem"
      />
    </div>
    <material-preview-modal
      :visible.sync="backgroundPreviewVisible"
      :material="previewingBackground"
    />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import { Empty, message } from 'ant-design-vue';
import MenuHeader from "../base/MenuHeader";
import TagMenu from "../base/TagMenu";
import MaterialStyleList from "../base/MaterialStyleList";
// import LabelOption from "../base/LabelOption";
import FilterBox from '../base/FilterBox';
import LottiePreview from "./LottiePreview";
import MaterialLibraryList from "./MaterialLibraryList";
import { fakeFunction } from "../../utils/util";
import { get } from "../../utils/api";
import { encodeURIIfNeeded, getImageAspectRatio, getVideoAspectRatio } from "../../utils";
import icons from './materialTypeIcons';

import MaterialPreviewModal from '../../series/MaterialPreviewModal';
import MaterialCategory from './MaterialCategory';
import IconList from './IconList';
import { themeNames } from '../../utils/iconList';
import webSocket from '../../utils/webSocket';
import uploadButton from './fisher/uploadButton.vue'

const allSiteKey = "allSites" + Math.random();

export default {
  name: "MaterialMenu",
  components: {
    MenuHeader,
    TagMenu,
    MaterialStyleList,
    // LabelOption,
    FilterBox,
    LottiePreview,
    MaterialPreviewModal,
    MaterialCategory,
    IconList,
    MaterialLibraryList,
    uploadButton
  },
  data: function () {
    return {
      currentOp: "public",
      loadingStatus: "loaded",
      page: 1,
      order: "id",
      liFisherOrder: "create_time",
      material: "",
      progress: 0,
      material_type: "",
      loadMore: 0,
      presetType: '', // 组件/动画 tab值
      publicType: 'hot', // 素材库 tab值
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      currentLiFisherSite: null,
      catsActive: "",
      categoryCollapsed: true,
      backgroundType: '8',
      presetTypes: [
        {
          value: 'effects',
          name: '特效',
          customIcon: 'effect'
        },
        {
          value: '1',
          name: '组件',
          icon: 'appstore'
        },
        {
          value: 'lottiefiles',
          name: '动画',
          customIcon: 'lottie'
        },
        {
          value: '2',
          name: '贴纸',
          icon: 'smile'
        },
        {
          value: 'icons',
          name: '图标',
          icon: 'ant-design'
        },
        {
          value: 'background',
          name: '背景',
          icon: 'picture'
        },
        {
          value: 'materials',
          name: '系统素材',
          icon: 'folder-open'
        }
      ],
      icons,
      backgroundPreviewVisible: false,
      previewingBackground: null,
      catsHeight: 32,
      iconType: 'Outline',
      themeNames,
      tag: '',
      materialTags: [],
      materialTagTotal: 0,
      materialTagPage: 1,
      codeBoxShow: false,
      qrcodeOverdue: false
    };
  },
  computed: {
    ...mapState([
      'isFisher',
      "materialList",
      "editStatus",
      "currentSubmenu",
      "presets",
      "liFisherSites",
      "presetsCats",
      'uploadModalMarker',
      "myMateriaCheckedList",
      "myMateriaChecked"
    ]),
    ...mapGetters(["revealMask"]),
    showingMenuType() {
      return this.currentOp === 'public' ? this.presetType : '';
    },
    showingMaterials() {
      return this.currentOp !== 'public' || this.presetType === 'materials';
    },
    fetchMarker() {
      const {
        material,
        currentOp,
        presetType,
        publicType,
        currentLiFisherSite,
        catsActive,
        uploadModalMarker,
        order,
        liFisherOrder,
        material_type,
        backgroundType,
        tag
      } = this;
      console.log(this.$store.state.screenRatio)
      return [currentOp]
        .concat(
          !this.showingMaterials
            ? [presetType, catsActive].concat(
              this.presetType === "1"
                ? [this.$store.state.screenRatio, material]
                : this.presetType === 'background'
                  ? [backgroundType, material]
                  : [],
              currentLiFisherSite || []
            )
            : currentOp === "public"
              ? [publicType, catsActive, material, material_type, order].concat(currentLiFisherSite || [])
              : currentLiFisherSite
                ? [material, material_type, currentLiFisherSite, liFisherOrder]
                : [material, material_type, order, uploadModalMarker, tag]
        )
        .join(",");
    },
    tagList() {
      return [
        { tag: "素材库", op: "public" },
        { tag: "我的素材", op: "mine" }
      ];
    },
    spacerHeight() {
      if (this.currentOp === "mine") {
        return this.currentLiFisherSite ? 128 : 168;
      }
      return this.presetType === 'materials' || this.presetType === 'background' || this.presetType === 'icons' ? 148 : this.presetType ? 110 : 96;
    },
    catSpacerHeight() {
      if (this.isFisher && this.currentOp === 'mine') {
        return this.spacerHeight + (
          this.catShow ? this.catsHeight : this.catsHeight
        );
      }
      return this.spacerHeight + (
        this.catShow ? this.catsHeight : 0
      );
    },
    panelList() {
      let list = [{
        title: '全部类型',
        radio: this.material_type || '',
        prop: 'material_type',
        list: [
          { name: "视频", value: "2" },
          { name: "图片", value: "1" }
        ],
        disabled: this.currentSubmenu === "ImageStampInfo",
        initial: this.currentSubmenu === "ImageStampInfo" ? '1' : ''
      }]
      let orderOptionList = []
      if (this.currentLiFisherSite) {
        orderOptionList = [{
          title: '排序',
          radio: this.liFisherOrder || 'create_time',
          initial: 'create_time',
          prop: 'liFisherOrder',
          list: [
            { name: "最新排序", value: "create_time" },
            { name: "热门排序", value: "is_used" },
          ]
        }]
        let fisherSiteList = [{
          title: '全部站点',
          radio: this.currentLiFisherSite || allSiteKey,
          initial: allSiteKey,
          prop: 'currentLiFisherSite',
          list: this.liFisherSites.map((s) => ({ name: s.site_name || s.domain, value: s.id }))
        }]
        return fisherSiteList.concat(list, orderOptionList)
      }
      orderOptionList = this.currentOp === 'mine' ? [{
        title: '标签',
        radio: this.tag, // TODO:
        prop: 'tag',
        list: [{ name: '全部', value: '' }].concat(this.materialTags)
      }] : [{
        title: '排序',
        radio: this.order || 'id',
        initial: 'id',
        prop: 'order',
        list: [
          { name: "最新排序", value: "id" },
          { name: "热门排序", value: "hots" },
        ]
      }]
      return list.concat(orderOptionList)
    },
    catShow() {
      // 动画/贴纸
      let sticker = this.currentOp === 'public' && (this.presetType === '2' || this.presetType === 'background' || this.lottieType);
      // 素材
      let isHotPublic = this.showingMenuType === 'materials' && this.publicType === 'hot';
      return sticker || isHotPublic;
    },
    lottieType() {
      switch (this.presetType) {
        case 'lottiefiles':
          return 1;
        case 'effects':
          return 2;
      }
      return 0;
    },
    searchDisabled() {
      return !this.showingMaterials && this.presetType != '1' && this.presetType !== 'background' && this.presetType !== 'icons';
    }
  },
  methods: {
    ...mapActions([
      'getMaterialList',
      'handleUploadFile',
      'addMaterialItem',
      'replaceMaterialItem',
      'addPresetItem',
      'getPresetList',
      'addStickerItem',
      'addLottieItem',
      'setMaterialTop',
      'deleteMaterial',
      'getLottieCats',
      'getAssemblyCats',
      'getHotPublicCats',
      'delCollect',
      'addCollect'
    ]),
    ...mapMutations([
      'handleStampUrl',
      'handleMaterialList',
      'handlePresets',
      'handleLoading',
      'handlePresetsCats',
      'handleUploadModalShow',
      'handleUploadModalType',
      'handleMyMateriaChecked',
      'handleMyMateriaCheckedList'
    ]),
    onSearch(material) {
      this.material = material;
    },
    handleOptionConfirm(e) {
      console.log(e);
      Object.keys(e).forEach(pk => {
        this[pk] = e[pk];
      });
    },
    handleTagClick(tag) {
      if (this.myMateriaChecked) {
        this.cancelCheck()
      }
      this.handleMaterialList([]);
      this.handlePresets([]);
      this.currentLiFisherSite = null;
      this.currentOp = tag;
      this.catsActive = "";
      this.categoryCollapsed = true;
      console.log('tag',tag);
      if (this.isFisher && tag === 'mine') {
        this.enterLiFisherSite()
      }
    },
    async listenerWebscoket() {
      var _t = this;
      this.websocket = await webSocket();
      this.websocket.addEventListener('message', function (event) {
        if (event.data) {
          var data = JSON.parse(event.data)
          if (data.event_type == 5) {
            _t.qrcodeOverdue = true;
          }
          if (data.event_type == 6) {
            _t.fetchMaterialList()
          }
        }
      });
    },
    fetchMaterialList(getMore = false) {
      if (!getMore) {
        this.page = 1;
        this.lastPage = false;
        if (this.myMateriaChecked) {
          this.cancelCheck()
        }
      }
      const {
        order,
        page,
        material,
        currentOp: tag,
        material_type,
        presetType,
        currentLiFisherSite,
        liFisherOrder,
        catsActive,
        showingMaterials,
        tag: materialTag
      } = this;
      if (this.lastPage) {
        return;
      }
      this.loadingStatus = 'loading';
      if (!showingMaterials) {
        console.log('Showing Presets');
        if (this.lottieType) {
          return get('lottie/list', {
            size: 60,
            page,
            type: catsActive,
            categoryType: this.lottieType
          }).then(({ list, total }) => {
            this.loadingStatus = 'loaded';
            this.lastPage = page * 60 >= total;
            this.handlePresets(getMore ? this.presets.concat(list) : list);
            this.page++;
            setTimeout(this.scrollEvent, 300);
          });
        }
        if (!getMore) {
          this.handlePresets([]);
        }
        if (!presetType || presetType === 'icons') {
          return;
        }
        let type = presetType;
        if (type === 'background') {
          type = +this.backgroundType; // or 9
        }
        return this.getPresetList({ type, page, classify: catsActive, name: material }).then(val => {
          if (val && !this.showingMaterials) {
            this.loadingStatus = 'loaded';
            this.lastPage = val.lastPage;
            this.page++;
            setTimeout(this.scrollEvent, 300);
          }
        });
      }
      console.log('currentLiFisherSite',currentLiFisherSite);
      if (currentLiFisherSite ) {
        console.log('currentLiFisherSite', currentLiFisherSite)
        return get('fish/material', {
          site_id: currentLiFisherSite === allSiteKey ? '' : currentLiFisherSite,
          page_number: page,
          material_type,
          keyword: material,
          sort_by: liFisherOrder,
        }).then(({ list, page_count }) => {
          this.lastPage = page >= page_count;
          let materialList = list.map((item) => ({
            material: item.material_name,
            material_type: item.extend === "mp4" ? 2 : 1,
            material_url: item.url,
            coverUrl: item.cover_url,
          }));
          if (getMore) {
            materialList = this.materialList.concat(materialList);
          }
          this.handleMaterialList(materialList);
          this.loadingStatus = "loaded";
          this.page++;
          setTimeout(this.scrollEvent, 300);
        });
      }
      console.log(this.currentOp)
      if (!getMore) {
        this.handleMaterialList([]);
      }
      this.$store.dispatch('getUploadSpace');

      return this.getMaterialList({
        order,
        page,
        material,
        u_id: tag === "mine" ? "" : "0",
        material_type: material_type || '1,2', // both videos and images, but no audio
        classify: this.showingMenuType === 'materials' && this.publicType === 'hot' ? 2 : 1,
        category: this.catsActive || 0,
        label: tag === 'mine' ? materialTag : ''
      }).then((val) => {
        if (val && showingMaterials) {
          this.lastPage = val.lastPage;
          this.page++;
          setTimeout(this.scrollEvent, 300);
          this.loadingStatus = "loaded";
        }
      });
    },
    scrollEvent() {
      const menu = this.$el;
      if (
        (!this.showingMaterials && +this.presetType === 1) ||
        this.loadingStatus === "loading"
      ) {
        return;
      }
      if (menu.scrollTop + menu.clientHeight >= menu.scrollHeight - 30) {
        this.loadMore++;
      }
    },
    stickerStyle(item) {
      const url = item.thumbnail;
      return {
        backgroundImage: `url(${encodeURIIfNeeded(url)})`,
      };
    },
    enterLiFisherSite() {
      this.handleMaterialList([]);
      this.currentLiFisherSite = allSiteKey;
      if (this.isFisher) {
        console.log('isFisher',this.isFisher, this.$store.state.fisherInfo.siteId);
        this.currentLiFisherSite = this.$store.state.fisherInfo.siteId || allSiteKey
        console.log('currentLiFisherSite', this.currentLiFisherSite);
      }
    },
    exitLiFisherSite() {
      this.currentLiFisherSite = null;
    },
    fakeFunction,
    async handleTop({ id, value }) {
      this.handleLoading(true);
      await this.setMaterialTop({ id, value });
      message.info(value ? '置顶成功' : '取消置顶成功');
      await this.fetchMaterialList();
      this.handleLoading(false);
    },
    // 删除选中的素材
    async delCheckList() {
      this.handleDelete({ id: this.myMateriaCheckedList.join(',') });
    },
    // 取消复选
    cancelCheck() {
      this.handleMyMateriaChecked(false)
      this.handleMyMateriaCheckedList([])
    },
    handleDelete({ id }) {
      this.deleteMaterial({
        id,
        done: this.fetchMaterialList
      });
    },
    handleAddTags() {
      if (!this.myMateriaCheckedList.length) {
        this.$message({
          showClose: true,
          message: '请选择要打标签的素材',
          type: 'warning',
          duration: 3000,
          offset: 100
        })
        return;
      }
      this.$refs.MaterialStyleList.showMaterialAddTags(
        this.myMateriaCheckedList.join(',')
      );
    },
    getClassify() {
      this.handlePresetsCats([]);
      if (!this.showingMaterials) {
        if (this.lottieType) {
          this.getLottieCats(this.lottieType);
        } else if (this.presetType === "2" || this.presetType === 'background') {
          this.getAssemblyCats(this.presetType === 'background' ? this.backgroundType : '2');
        }
      } else if (this.publicType === 'hot') {
        this.getHotPublicCats()
      }
    },
    toggleCats(cat) {
      if (this.catsActive !== cat) {
        this.catsActive = cat;
      }
    },
    handleOnClickItem(data){
      this.onClickItem(data.type,data.item,data.lottieType);
    },
    onClickItem(type, item, lottieType) {
      if (item.noAccess) {
        this.$store.commit('handleMealDialogVisible', true);
      } else {
        if (type == '1') {
          this.addPresetItem(item.id);
        } else if (type == '2') {
          this.addStickerItem(item);
        } else if (type == 'lottie') {
          this.addLottieItem({ item, type: lottieType });
        }
      }
    },
    toggleUploadDialog(val) {
      this.handleUploadModalShow(val);
      this.handleUploadModalType(3);
    },
    async toggleCodeBoxDialog(nextShow) {
      if (nextShow) {
        var codeUrl = await get('qrcode/material-url');
        this.codeBoxShow = true;
        this.qrcodeOverdue = false;
        this.$nextTick(() => {
          this.$refs.qrcode.innerHTML = "";
          new QRCode(this.$refs.qrcode, {
            text: codeUrl.url,
            width: 200,
            height: 200
          });
        });
      } else {
        this.codeBoxShow = false;
      }
    },
    repaintQrcode() {
      this.codeBoxShow = false;
      this.toggleCodeBoxDialog(true);
      this.qrcodeOverdue = false;
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'assembly', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'assembly', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
    handlePresetType(type) {
      this.presetType = type
    },
    resetPresets() {
      this.categoryCollapsed = true;
      this.catsActive = "";
      this.getClassify();
      this.handlePresets([]);
    },
    back() {
      this.presetType = '';
    },
    backgroundThumbnail(url) {
      return this.backgroundType === '8'
        ? url + '?x-oss-process=image/resize,w_216'
        : url + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_216';
    },
    async addBackground(item) {
      const { editingContainer, screenRatio, effects, currentProgress } = this.$store.state;
      const { activeFragment: frag } = this.$store.getters;
      const type = this.backgroundType === '8' ? 'image' : 'video';
      const key = Date.now() + '';
      let ownDuration = 0;
      this.$store.commit('handleLoading', true);
      const ratio = await (
        type === 'video' ? getVideoAspectRatio(item.thumbnail, video => {
          ownDuration = video.duration;
        }) : getImageAspectRatio(item.thumbnail)
      );
      this.$store.commit('handleLoading', false);

      const usedWidth = Math.min(400 * (ratio || 1.5), screenRatio * 480);
      const height = usedWidth / ratio;

      const left = editingContainer ? 0 : (screenRatio * 480 - usedWidth) / 2;
      const top = editingContainer ? 0 : (480 - height) / 2;

      const effect = {
        id: key,
        type,
        locked: false,
        hidden: false,
        content: {
          src: item.thumbnail,
          name: item.name,
          top,
          left,
          width: usedWidth,
          height,
          rotate: 0,
          brightness: 1,
          opacity: 100,
          flip: 'none',
          shadow: false,
          shadowX: 1,
          shadowY: 3,
          shadowBlur: 5,
          shadowColor: '#000000',
          radius: 0
        },
        enter: 'none',
        enterDuration: 1e3,
        leave: 'none',
        leaveDuration: 1e3,
        showTracks: false,
        duration: frag.duration,
        start: 0,
        tracks: [
          {
            id: 1,
            start: 1e3,
            duration: 1e3,
            text: 'animation',
            effectType: 'gradientFade',
            params: {
              direction: 'left'
            }
          }
        ]
      };
      if (type === 'video') {
        effect.content.loop = true; // loop by default
        effect.content.mute = false;
        effect.content.volume = 100;
        effect.content.musicVolume = 100;
        // effect.duration = Math.min(ownDuration, frag.duration - currentProgress + frag.start);
        effect.content.crop = [0, ownDuration];
        effect.content.playbackRate = 1;
      } else {
        effect.content.repeat = false;
      }
      this.$store.commit('handleEffects', {
        ...effects,
        [key]: effect
      });

      this.$store.dispatch('changeActiveFragment', {
        ...frag,
        background: key,
        backgroundType: type
      });

      this.$store.dispatch('selectBackground');
    },
    previewBackground(item) {
      const type = this.backgroundType === '8' ? '1' : '2';
      this.backgroundPreviewVisible = true;
      this.previewingBackground = {
        material_type: type,
        material_url: item.thumbnail
      };
    },
    async getMaterialTags() {
      const { list, total } = await get('label/label-list', { page: this.materialTagPage });
      this.materialTags = (this.materialTagPage === 1 ? [] : this.materialTags).concat(list.map(item => ({
        name: item.name,
        value: item.name
      })));
      this.materialTagTotal = total;
    },
    reloadMaterialTags() {
      if (this.materialTagPage !== 1) {
        this.materialTagPage = 1;
      } else {
        this.getMaterialTags();
      }
    },
    loadNextMaterialTags() {
      this.materialTagPage++;
    },
    onUpload () {
      console.log('onUpload');
      this.handleTagClick('public')
      this.$nextTick(() => {
        this.handleTagClick('mine')
      })
    }
  },
  mounted() {
    if (this.currentSubmenu === "ImageStampInfo") {
      this.material_type = "1";
    }
    if (this.revealMask) {
      this.currentOp = "mine";
    }
    this.fetchMaterialList();
    this.reloadMaterialTags();
    this.listenerWebscoket();
    console.log(this.materialList)
    if (this.isFisher) {
      this.currentLiFisherSite = this.$store.state.fisherInfo.siteId
    }
  },
  beforeDestroy() {
    this.handlePresets([]);
  },
  watch: {
    loadMore() {
      if (this.loadingStatus !== "loading") {
        this.fetchMaterialList(true);
      }
    },
    fetchMarker(val) {
      console.log(val);
      this.fetchMaterialList();
    },
    revealMask(val) {
      if (val && !this.showingMaterials) {
        this.currentOp = "mine";
      }
    },
    currentOp(val) {
      if (this.revealMask && val === 'public') {
        this.presetType = 'materials';
      } else if (this.presetType) {
        this.presetType = '';
      } else {
        this.resetPresets();
      }
    },
    presetType(val) {
      if (val === 'background' && this.backgroundType !== '8') {
        this.backgroundType = '8';
      } else {
        this.resetPresets();
      }
    },
    backgroundType() {
      this.resetPresets();
    },
    publicType() {
      this.resetPresets();
    },
    catsHeight(value, prev) {
      console.log('watching catsHeight');
      console.log(value);
      const el = this.$el;
      // let that = this;
      const offset = value - prev;
      if (this.catShow && el.scrollTop >= this.spacerHeight) {
        el.scrollTop -= offset;
      }
    },
    backgroundPreviewVisible(val) {
      if (!val) {
        this.previewingBackground = null;
      }
    },
    materialTagPage() {
      this.getMaterialTags();
    }
  }
};
</script>

<style scoped>
.sticker-item:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.material-menu {
  background: rgba(247, 248, 249, 1);
  box-shadow: -1px 0 0 0 rgba(220, 220, 222, 1);
  padding: 0 16px 0 16px;
  height: 100%;
  overflow-y: auto;
}
.empty {
  height: 159px;
  transition: 100ms;
}

.material-menu-top {
  background: #f7f8f9;
  position: absolute;
  z-index: 2;
  width: 247px;
  padding: 10px 14px 0 0;
}

.material-back {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 10px;
  margin-top: 2px;
}

.material-back__btn {
  display: flex;
  padding-left: 0;
  height: 28px;
  align-items: center;
}

.material-back__icon {
  font-size: 16px;
}

.filter-box {
  display: flex;
  align-items: center;
  margin-top: 9px;
}

.material-option {
  margin-top: 0;
}

.material-option ::v-deep .ant-select-selection {
  border-color: #d9d9d9;
  height: 32px;
  border-radius: 4px 0 0 4px;
  border-right: 0;
}
.material-option ::v-deep .ant-select-sm .ant-select-selection__rendered {
  line-height: 30px;
}

.option-group {
  display: flex;
  justify-content: space-between;
}

.video-template-item {
  margin: 12px 14px 6px 0;
  width: 108px;
  position: relative;
  cursor: pointer;
}

.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.video-clip-custom-img {
  object-fit: cover;
  width: 100%;
  height: 60px;
  transition: 0.2s;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  padding-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-template-item:hover {
  color: #007eff;
}

.video-template-item:hover .video-clip-custom-img {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06), 0 0 8px rgba(0, 0, 0, 0.1);
}

.header-radio-group {
  margin: 8px 0 0;
  display: flex;
}

.sticker-item {
  width: 70px;
  height: 70px;
  margin: 11px 11px 0 0;
  position: relative;
  background: #fff
    url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAyIDIiPjxwYXRoIGQ9Ik0wIDBMMCAxTDIgMUwyIDJMMSAyTDEgMHoiIGZpbGw9InJnYmEoMCwwLDAsLjIpIi8+PC9zdmc+);
  background-size: 12px;
}

.sticker-item__content,
.sticker-item:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sticker-item:after {
  content: "";
  transition: 0.3s;
}

.sticker-item:hover:after {
  box-shadow: inset 0 0 0 2px #007eff;
}

.sticker-item__content {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.effect-sticker-item {
  width: 108px;
  height: 60px;
  margin: 11px 14px 0 0;
  position: relative;
  background: url(https://img001.aivideo8.com/ai_video/U449/2021-07-23/img/1627005227557.jpg)
    no-repeat;
  background-size: cover;
}

.folder {
  display: inline-flex;
  margin: 10px 10px 0 0;
  width: 71px;
  height: 71px;
  cursor: pointer;
  vertical-align: middle;
  padding: 12px 5px 5px;
  white-space: nowrap;
  flex-direction: column;
  font-size: 12px;
  background: transparent center no-repeat;
  background-size: contain;
}

.folder:hover {
  color: #007eff;
}

.folder--lifisher {
  background-image: url("/preview/icon/folder-lifisher.png");
  justify-content: flex-end;
}

.folder--back {
  background-image: url("/preview/icon/folder-empty.png");
  justify-content: center;
}

.folder__text {
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preset-type-item {
  display: flex;
  width: 100%;
  max-width: 233px;
  border-radius: 2px;
  height: 48px;
  margin-bottom: 12px;
  align-items: center;
}

.preset-type-item ::v-deep .anticon {
  font-size: 16px;
  margin: 1px;
}

.preset-type-item .preset-type-item__icon {
  font-size: 18px;
  margin: 0;
}

.preset-type-item ::v-deep .anticon svg {
  display: block;
}
.upload-box {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}
.upload-type {
  width: 48%;
  position: relative;
}
.code-box {
  width: 200px;
  height: 200px;
  position: relative;
}
.code-box .qrcode {
  width: 100%;
  height: 100%;
}
.qrcode-overdue {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.qrcode-overdue span {
  cursor: pointer;
  color: #007eff;
}
</style>

<style>
.material-menu > .ant-spin-nested-loading > div > .ant-spin .ant-spin-dot {
  position: fixed;
  top: 400px;
  left: 200px;
}

.video-template-list .ant-spin-container {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
  align-items: flex-start;
  align-content: start;
}

.header-radio-group .ant-radio-button-wrapper {
  height: 30px;
  line-height: 28px;
  flex-grow: 1;
  text-align: center;
}

.check-operation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
}

.check-operation .ant-btn {
  width: 68px;
  padding: 0;
}

.background-previewer {
  position: relative;
  z-index: 0;
}

.background-previewer__btn {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  width: 24px;
  height: 24px;
  padding: 0;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-previewer__btn svg {
  display: block;
}

.background-previewer__btn:hover,
.background-previewer__btn:focus {
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
}
</style>
